import { render, staticRenderFns } from "./ProgrammePlanCard.vue?vue&type=template&id=07037e3c&scoped=true&"
import script from "./ProgrammePlanCard.vue?vue&type=script&lang=ts&"
export * from "./ProgrammePlanCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProgrammePlanCard.vue?vue&type=style&index=0&id=07037e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07037e3c",
  null
  
)

export default component.exports